import React from 'react';
import { useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { getTextInputFieldError } from './text-input-field-utils';
import { TextInputWUT } from '../../inputs/text-input-wut/text-input-wut';
export const TextInputFieldWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    placeholder,
    required = false,
    description,
    value = '',
    onChange,
    onBlur,
    onFocus,
    error,
    type = 'text',
    disabled = false,
    readOnly,
    customErrors,
    fieldType,
    validation,
    countryCode,
    prefix,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const _error = getTextInputFieldError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, fieldType, countryCode == null ? void 0 : countryCode.toLocaleLowerCase());
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TextInputWUT, {
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      type: type,
      disabled: disabled,
      readOnly: readOnly,
      prefix: prefix,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy,
      hasError: hasError,
      fieldId: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=text-input-field-wut.js.map